import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';

export const middlewareLogin = (props) => {
	const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE.USER));
	console.log('checkLogin', props, user);
	if (props.location.pathname === '/login' && user === null) {
		return true;
	}

	if (user === null) {
		window.location.href = '/login';
	}

	if (props.location.pathname === '/' && user === null) {
		window.location.href = '/login';
	}

	return false;
};
